import { marked, Tokens } from 'marked';

marked.use({
  renderer: {
    table(token: Tokens.Table): string {
      const cell = (c: Tokens.TableCell): string => `<td>${this.parser.parseInline(c.tokens)}</td>`;
      const rows = [token.header, ...token.rows]
        .map(row => `<tr>${row.map(cell).join('')}</tr>`)
        .join('');

      return `<table><tbody>${rows}</tbody></table>`;
    },
  },
});

export function markdownToHtml(md: string): string {
  const trimmed = md?.trim() ?? '';

  if (trimmed === '') return '';

  const looksLikeMarkdown = /^#+\s|^\s*[-*+]\s|^\d+\.\s|\[.+\]\(.+\)|\*\*[^*]+\*\*|__[^_]+__/m.test(
    trimmed
  );

  const looksLikeTable = /^\s*\|?\s*:?-{1,}:?\s*(\|\s*:?-{1,}:?\s*)+\|?\s*$/m.test(trimmed);

  if (!looksLikeMarkdown && !looksLikeTable) return trimmed;

  try {
    return marked(trimmed, { async: false });
  } catch {
    return trimmed;
  }
}
